<template>
    <div
        :class="[
            'shrink-0 z-[60] flex justify-center items-center w-full px-[20px] lg:px-[40px] py-[22px] bg-white border-t border-gray-light',
            'h-[90px] max-h-[90px] relative'
        ]"
        v-if="!shouldShowSummary"
    >
        <div
            v-if="shouldShowPaintfillRequirement && isDirty"
            class="flex text-[14px] font-normal text-red-error font-oceanside absolute top-0 left-[50%] translate-x-[-50%] gap-x-[4px] whitespace-nowrap"
        >
            <img
                src="../assets/images/icons/exclamation-red.svg"
                width="12"
                height="12"
                alt="Exclamation mark"
            />
            {{ $t('PAINTFILL_SELECTION_REQUIRED') }}
        </div>
        <div
            v-if="shouldShowStampsRequirement && isDirty"
            class="flex text-[14px] font-normal text-red-error font-oceanside absolute top-0 left-[50%] translate-x-[-50%] gap-x-[4px] whitespace-nowrap"
        >
            <img
                src="../assets/images/icons/exclamation-red.svg"
                width="12"
                height="12"
                alt="Exclamation mark"
            />
            {{ $t('STAMPS_SELECTION_REQUIRED') }}
        </div>
        <div
            v-if="shouldShowInitialsRequirement && isDirty"
            class="flex text-[14px] font-normal text-red-error font-oceanside absolute top-0 left-[50%] translate-x-[-50%] gap-x-[4px] whitespace-nowrap"
        >
            <img
                src="../assets/images/icons/exclamation-red.svg"
                width="12"
                height="12"
                alt="Exclamation mark"
            />
            {{ $t('INITIALS_SELECTION_REQUIRED') }}
        </div>
        <div
            v-if="shouldShowGenericRequirement && isDirty"
            class="flex text-[14px] font-normal text-red-error font-oceanside absolute top-0 left-[50%] translate-x-[-50%] gap-x-[4px] whitespace-nowrap"
        >
            <img
                src="../assets/images/icons/exclamation-red.svg"
                width="12"
                height="12"
                alt="Exclamation mark"
            />
            <span class="error-message-mobile">
                {{ $t('GENERIC_SELECTION_REQUIRED_COMPACT') }}
            </span>
            <span class="error-message-desktop">
                {{ $t('GENERIC_SELECTION_REQUIRED') }}
            </span>
        </div>
        <div class="flex w-full items-center gap-[16px]">
            <animated-cta-button
                @click="applySelections"
                class="w-full"
                :is-disabled="isDisabled"
                variant="wide"
            >
                {{ buttonText || $t('APPLY_SELECTIONS') }}
            </animated-cta-button>
        </div>
    </div>
</template>

<script>
    import AnimatedCtaButton from './buttons/AnimatedCtaButton.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            AnimatedCtaButton,
        },

        props: {
            isDisabled: {
                type: Boolean,
                default: false,
            },

            shouldShowPaintfillRequirement: {
                type: Boolean,
                default: false,
            },

            shouldShowStampsRequirement: {
                type: Boolean,
                default: false,
            },

            shouldShowInitialsRequirement: {
                type: Boolean,
                default: false,
            },

            shouldShowNoCustomizationRequirement: {
                type: Boolean,
                default: false,
            },

            shouldShowGenericRequirement: {
                type: Boolean,
                default: false,
            },

            isDirty: {
                type: Boolean,
                default: false,
            },

            shouldCloseGroupOverlay: {
                type: Boolean,
                default: true,
            },

            buttonText: {
                type: String,
                default: '',
            },
        },

        computed: {
            shouldShowSummary() {
                return this.appStore.shouldShowSummary;
            },
        },

        methods: {
            setShowGroupOverlay(value) {
                this.appStore.setShowGroupOverlay(value);
            },

            applySelections() {
                if (this.isDisabled) {
                    this.$emit('handle-disabled');
                    return;
                }

                this.$emit('apply-selections');

                if (this.shouldCloseGroupOverlay) {
                    this.setShowGroupOverlay(false);
                    this.appStore.scrollPanelToTop();
                }
            },
        },
    };
</script>

<style scoped>
    @media (max-width: 399px) {
        .error-message-mobile {
            display: block;
        }

        .error-message-desktop {
            display: none;
        }
    }

    @media (min-width: 400px) {
        .error-message-mobile {
            display: none;
        }

        .error-message-desktop {
            display: block;
        }
    }
</style>